import { render, staticRenderFns } from "./ProfiloSanitario.vue?vue&type=template&id=2489edcf&"
import script from "./ProfiloSanitario.vue?vue&type=script&lang=js&"
export * from "./ProfiloSanitario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports